<template>
  <div>
    <h4 class="text-center">📝 我的话题和回复</h4>
    <hr />
    <p>
      话题置顶余额
      <el-tooltip
        class="item"
        effect="dark"
        content="每发布一个超过24小时的话题，您将获得0.5个置顶"
      >
        <i class="el-icon-info"></i>
      </el-tooltip>
      ：{{ user.pin_count }}
    </p>
    <p>
      活跃话题和限制
      <el-tooltip
        class="item"
        effect="dark"
        content="同时拥有的活跃话题数，开通会员可以获得更多活跃话题"
      >
        <i class="el-icon-info"></i>
      </el-tooltip>
      ：{{ topicLimit }}
    </p>
    <UserSummary :id="user.id"></UserSummary>
  </div>
</template>

<script>
import UserSummary from "../views/UserSummary.vue";
import { mapMutations, mapState } from "vuex";

export default {
  data: function() {
    return {
      topicLimit: 3
    };
  },
  components: {
    UserSummary
  },
  computed: {
    ...mapState(["user"])
  },
  mounted: function() {
    this.fetchTopicLimit();
  },
  methods: {
    ...mapMutations(["updateUser"]),
    fetchTopicLimit() {
      this.topicLimit = "";
      this.$http
        .get("/user/topic-limit")
        .then(res => (this.topicLimit = res.data))
        .catch(() => (this.topicLimit = 3));
    }
  }
};
</script>
